import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IconWrapper, FILL_COLOR_CLASS_NAMES } from "./IconWrapper";
import classNames from "classnames";
const SortDownIcon = (props) => {
    const colorClassName = props.color
        ? FILL_COLOR_CLASS_NAMES[props.color]
        : null;
    return (_jsx(IconWrapper, Object.assign({}, props, { children: _jsxs("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", Object.assign({ d: "m30.444 23.438-9.103 9.406a1.884 1.884 0 0 1-1.34.557c-.486 0-.971-.186-1.34-.558L9.56 23.438c-1.194-1.19-.35-3.238 1.343-3.238H29.1c1.687 0 2.533 2.049 1.343 3.238Z", fill: "currentColor" }, props, { className: classNames(colorClassName, props.className) })), _jsx("title", { children: props.title })] })) })));
};
export default SortDownIcon;
//# sourceMappingURL=SortDownIcon.js.map